var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"org-page"},[_c('page-title',[_vm._v(_vm._s(_vm.$t('orgs.subdivision_info')))]),_vm._v(" "),(_vm.org)?_c('org-page',{attrs:{"org":_vm.org}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }